import * as React from "react";
import { Helmet } from "react-helmet";

import { usePage } from "@montana/containers/page";
import { staticSettings } from "@montana/helpers/static-settings.helper";
import { CartPageKind, ConfirmationPageKind, ProductPageKind } from "@montana/pages/dynamic-page.component";
import { useProduct } from "@montana/containers/product";
import { useDynamicSettings } from "@montana/containers/dynamic-settings";

export const PageHead: React.FC = React.memo((): JSX.Element => {

    const {
        metaTitle,
        metaKeywords,
        metaDescription,
        canonicalUrl,
        hrefLangs,
        categorySeoTitle,
        categoryMetaDescription,
        kind,
        disableIndexing,
    } = usePage();
    const { markets } = useDynamicSettings();

    const {
        seoTitle,
        seoDescription,
    } = useProduct();

    const siteName = 'Montana Furniture';
    const selectedMarket = markets?.find(m => m.isSelected)?.urlMarket;
    const alternateMarkets = markets?.filter(m => !m.isSelected);

    const title = kind === ProductPageKind ? seoTitle : (!!categorySeoTitle ? categorySeoTitle : (metaTitle || "Montana"));
    const description = kind === ProductPageKind ? seoDescription : (!!categoryMetaDescription ? categoryMetaDescription : (metaDescription || ""));

    return (
        <Helmet>
            <title>{title}</title>
            <meta key="title" name="title" content={title} />
            <meta key="description" name="description" content={description} />
            <meta key="keywords" name="keywords" content={metaKeywords || ""} />
            <meta key="author" name="author" content={siteName} />
            <meta key="copyright" name="copyright" content={siteName} />
            <meta key="generator" name="generator" content="CMS EPISERVER Commerce" />
            {(staticSettings.b2b || staticSettings.isDebugging || kind === ConfirmationPageKind || kind === 'CheckoutB2CPage' || kind === CartPageKind || kind === 'ShippingPage' || disableIndexing) && (
                <meta key="robots" name="robots" content="noindex" />
            )}
            {!!canonicalUrl && staticSettings.b2c && (
                <link key="canonical" rel="canonical" href={(staticSettings.spaUrl + canonicalUrl).toLowerCase()} />
            )}
            {staticSettings.b2c && hrefLangs?.map((hrefLang, index) => (
                <link rel="alternate" href={(staticSettings.spaUrl + hrefLang.url).toLowerCase()} hrefLang={hrefLang.languageCode} key={`hreflang-${hrefLang.languageCode}-${index}`} />
            ))}

            {/* Open Graph */}
            {!!title && <meta property="og:title" content={title} />}
            <meta key="og:type" property="og:type" content="website" />
            {!!canonicalUrl && <meta key="og:url" property="og:url" content={canonicalUrl} />}
            {!!description && <meta key="og:description" property="og:description" content={description} />}
            <meta key="og:site_name" property="og:site_name" content={siteName} />
            { !!selectedMarket && <meta key="og:locale" property="og:locale" content={selectedMarket.replace('-', '_')} />}
            { alternateMarkets?.map((m, i) => <meta key={`${m.urlMarket}-${i}`} property="og:locale:alternate" content={m.urlMarket?.replace('-', '_')} />)}
            {/* <meta property="og:image" content="" /> */}

            {/* Twitter */}
            <meta key="twitter:card" name="twitter:card" content="summary" />
            <meta key="twitter:title" name="twitter:title" content={title} />
            <meta key="twitter:description" name="twitter:description" content={description} />
            {/* <meta name="twitter:image" content="" /> */}
        </Helmet>
    );
});
